module.exports = __webpack_public_path__ + "img/DSC09174-min.cfb5658a.jpg";